import { useEffect } from 'react';
import './CartAddedToast.css';

export default function CartAddedToast({ visible, message = 'Product added to cart', onClose }) {
  useEffect(() => {
    if (!visible) return undefined;
    const timer = setTimeout(() => onClose?.(), 2500);
    return () => clearTimeout(timer);
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <div className="cart-added-toast" role="status" aria-live="polite">
      <span className="cart-added-toast__icon" aria-hidden="true">✓</span>
      <span className="cart-added-toast__text">{message}</span>
    </div>
  );
}
